"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFaqSchema = void 0;
const markdown_it_1 = __importDefault(require("markdown-it"));
/**
 * Converts a FAQ object into a FAQPage schema.
 * @param inputObject - The FAQ object to convert.
 * @returns The FAQPage schema JSON string or undefined if the input object is invalid.
 */
function getFaqSchema(inputObject) {
    if (isValidFaqList(inputObject) === false) {
        return undefined;
    }
    const md = new markdown_it_1.default();
    const convertedFaqs = inputObject;
    const seoFaqData = convertedFaqs
        .filter((faq) => !faq.usage || (faq.usage === 'SEOFAQ' && faq.shortDescription && faq.longDescription))
        .map((faq) => ({
        name: faq.question || faq.shortDescription,
        acceptedAnswer: {
            text: faq.answer || md.renderInline(faq.longDescription ?? ''),
            '@type': 'Answer',
        },
        '@type': 'Question',
    }));
    if (seoFaqData.length === 0) {
        return undefined;
    }
    else {
        return JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: seoFaqData,
        });
    }
}
exports.getFaqSchema = getFaqSchema;
/**
 * Type Guard: Checks if an unknown input is a valid FAQ array.
 */
function isValidFaqList(inputObject) {
    return (Array.isArray(inputObject) &&
        inputObject.length > 0 &&
        inputObject.some((item) => item &&
            typeof item === 'object' &&
            (('usage' in item && 'shortDescription' in item && 'longDescription' in item) ||
                ('question' in item && 'answer' in item))));
}
//# sourceMappingURL=faq-schema.js.map